export default class PORSiteToSiteConfiguration {

    inboundEndpointType!: string;

    endpointLocation!: string;

    endpointIP!: string;

    authenticationIP!: string;

    vpnMode!: string;

    negotiationMode!: string;

    replyDetection!: string;

    constructor(config: any) {
        this.inboundEndpointType = config.epType;
        this.endpointLocation = config.tunnelEPLocation;
        this.endpointIP = config.tunnelEPIP;
        this.authenticationIP = config.clientAuthIP;
        this.vpnMode = config.vpnMode;
        this.negotiationMode = config.negociationMode;
        this.replyDetection = config.replayDetection;
    }
}